export class FileSizeLimitExceededError extends Error {
  limit: number

  constructor(message: string, limit: number) {
    super(message)
    this.name = 'FileSizeLimitExceededError'
    this.limit = limit
  }
}
